import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FilterDefaultService } from '../../services/filter-default.service';
import { AuthInterceptor } from '../../../interceptor/auth.interceptor';
import { UtilService } from '../../util/util.service';

@Component({
  selector: 'app-page-confirmar-matricula.',
  templateUrl: './page-confirmar-matricula.component.html',
  styleUrls: ['./page-confirmar-matricula.component.css']
})
export class PageConfirmarMatriculaComponent implements OnInit {

  param = '/home';

  matriculaCentrus: string;
  matriculaBacen: string;

  constructor(
    private authInterceptor: AuthInterceptor,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.matriculaCentrus = this.activatedRoute.snapshot.params.pc;
    this.matriculaBacen = this.activatedRoute.snapshot.params.pb;
  }


  direcionarCentrus() {
    window.open(`${UtilService.CAMINHO_ACESSO_SISTEMA_PCD_CONSULTAR_DADOS}&cdcentrus=${this.authInterceptor.getJwtCdCentrus()}&matricula_dv=${this.matriculaCentrus}&origem_func=${1}`);
  }
  direcionarBacen() {
    window.open(`${UtilService.CAMINHO_ACESSO_SISTEMA_PCD_CONSULTAR_DADOS}&cdcentrus=${this.authInterceptor.getJwtCdCentrus()}&matricula_dv=${this.matriculaBacen}&origem_func=${3}`)
  }

}




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/layout/page-confirmar-matricula/page-confirmar-matricula.component.ts